import apiClient, { type PagedResponse } from '../client'
import type {
  PlantGateDetailResponse,
  PlantGateListItemResponse,
} from '../models/plantGate.models'

const BASE_PATH = '/plant/control-ingreso'

export const plantGateService = {
  async getAll(params?: {
    page?: number
    pageSize?: number
    search?: string
  }): Promise<PagedResponse<PlantGateListItemResponse>> {
    return apiClient.get<PagedResponse<PlantGateListItemResponse>>(BASE_PATH, params)
  },

  async getDetalle(shipmentId: string): Promise<PlantGateDetailResponse> {
    return apiClient.get<PlantGateDetailResponse>(`${BASE_PATH}/${shipmentId}`)
  },

  async refresh(shipmentId: string): Promise<PlantGateDetailResponse> {
    return apiClient.post<PlantGateDetailResponse>(`${BASE_PATH}/${shipmentId}/refresh`)
  },
}
